import axios from 'axios';
import Cookie from 'js-cookie';
// Declared in `../efkt/auth/storage.ts` and re-exported here unchanged, so every existing
// `@libs/api-v2/build/datahub/http` import across `v2/` keeps working. They live there rather than
// here because `datahub/` is deleted at cutover and the sign-in session these keys describe is not.
export { IS_ESOFT_USER_KEY, IS_AD_SESSION_KEY, isAdSession, HEADER_USER_ID_KEY, AUTH_LOGIN_KEY, AUTH_LOGOUT_KEY, AUTH_SCHEMA_KEY, AUTH_REFRESHING, RESET_PASSWORD_CODE_KEY, AUTH_RESET_PASSWORD_KEY, AUTH_REDIRECT_URL, MINDWORKING_REDIRECT_REFERENCE, } from '../efkt/auth/storage';
import { AUTH_LOGOUT_KEY, AUTH_SCHEMA_KEY, HEADER_USER_ID_KEY } from '../efkt/auth/storage';
const TOKEN_KEY = 'auth.token';
const TOKEN_PERSISTENCE = 365; // days
let errorHandler;
const blacklistedAuthorizationUrls = ['amazonaws.com'];
export const endpoints = {
    datahub: process.env.DATAHUB_API_ENDPOINT || 'https://datahub.stage.efkt.net',
};
function forgetAuthToken() {
    if (typeof window !== undefined) {
        Cookie.remove(TOKEN_KEY);
        const logoutUrl = localStorage.getItem(AUTH_LOGOUT_KEY);
        if (logoutUrl)
            window.location.href = logoutUrl;
    }
}
function getAuthToken() {
    return typeof window !== undefined ? Cookie.get(TOKEN_KEY) : undefined;
}
function setAuthToken(value, persist) {
    Cookie.set(TOKEN_KEY, value, {
        expires: persist ? TOKEN_PERSISTENCE : undefined,
    });
}
function createClient(baseURL, appendAuthorizationHeader = true) {
    const client = axios.create({
        baseURL,
    });
    if (appendAuthorizationHeader) {
        client.interceptors.request.use((requestConfig) => {
            var _a;
            const token = getAuthToken();
            if (token && !blacklistedAuthorizationUrls.some(url => { var _a; return ((_a = requestConfig.url) === null || _a === void 0 ? void 0 : _a.indexOf(url)) !== -1; })) {
                const authSchema = localStorage.getItem(AUTH_SCHEMA_KEY);
                requestConfig.headers.Authorization = `${authSchema ? `${authSchema} ` : ''}${token}`;
            }
            try {
                const userIdHeader = JSON.parse(localStorage.getItem(HEADER_USER_ID_KEY) || '');
                if ((userIdHeader === null || userIdHeader === void 0 ? void 0 : userIdHeader.value) && !((_a = requestConfig.url) === null || _a === void 0 ? void 0 : _a.includes('user/branches'))) {
                    requestConfig.headers[userIdHeader.header] = userIdHeader.value;
                }
            }
            catch (ex) {
                // noop
            }
            return requestConfig;
        });
    }
    client.interceptors.response.use(undefined, (error) => {
        if (errorHandler) {
            errorHandler(error);
        }
    });
    return client;
}
function setErrorHandler(handler) {
    errorHandler = handler;
}
export default {
    createClient,
    getAuthToken,
    setAuthToken,
    forgetAuthToken,
    setErrorHandler,
};
